/* RapidCare - collection page.
   1. Native Shopify filter + sort forms submit as plain GET (work without JS).
   2. With JS: on DESKTOP, changing any facet/sort navigates immediately.
      On MOBILE, facets collect in an off-canvas drawer and apply on "Show results"
      (avoids a full reload after every checkbox tap).
   3. Mobile filter drawer open/close (button, close, scrim, Esc). */
(function () {
  'use strict';
  var root = document.querySelector('[data-rc-collection]');
  if (!root) return;

  var mq = window.matchMedia('(max-width:900px)');
  var isMobile = function () { return mq.matches; };

  function submit(form) {
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.submit();
  }
  function submitDebounced(form) {
    clearTimeout(form._t);
    form._t = setTimeout(function () { submit(form); }, 350);
  }

  var facets = root.querySelector('[data-rc-facets]');
  if (facets) {
    facets.addEventListener('change', function (e) {
      if (e.target.type === 'number') { submitDebounced(facets); return; }
      // On mobile, wait for the explicit "Show results" tap.
      if (!isMobile()) submit(facets);
    });
    facets.addEventListener('input', function (e) {
      if (e.target.type === 'number') submitDebounced(facets);
    });
  }

  var sort = root.querySelector('[data-rc-sort]');
  if (sort) {
    sort.addEventListener('change', function () { submit(sort); });
  }

  /* ── Mobile filter drawer ─────────────────────────────────── */
  var sidebar = root.querySelector('[data-rc-sidebar]');
  var scrim = root.querySelector('[data-rc-facet-scrim]');
  var openBtn = root.querySelector('[data-rc-facet-open]');
  var closeBtn = root.querySelector('[data-rc-facet-close]');

  function openDrawer() {
    if (!sidebar) return;
    if (scrim) { scrim.hidden = false; requestAnimationFrame(function () { scrim.classList.add('show'); }); }
    sidebar.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!sidebar) return;
    sidebar.classList.remove('open');
    document.body.style.overflow = '';
    if (scrim) {
      scrim.classList.remove('show');
      setTimeout(function () { scrim.hidden = true; }, 260);
    }
  }

  if (openBtn) openBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (scrim) scrim.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && sidebar && sidebar.classList.contains('open')) closeDrawer();
  });

  // If the viewport grows back to desktop, make sure the drawer never stays stuck.
  mq.addEventListener && mq.addEventListener('change', function () {
    if (!isMobile()) closeDrawer();
  });
})();
